module.exports = __webpack_public_path__ + "static/PFB_INTRO_IMAGES_01-58755d7eadf2c8a0c744954c3d4fec55.jpg";